import React, { useState } from 'react';
import api from '../services/api';
import './LinkForm.css';

const LinkForm = ({ onLinkCreated }) => {
  const [alias, setAlias] = useState('');
  const [url, setUrl] = useState('');
  const [customCode, setCustomCode] = useState('');
  const [isWhatsapp, setIsWhatsapp] = useState(false);
  const [whatsappPhone, setWhatsappPhone] = useState('');
  const [whatsappMessage, setWhatsappMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const payload = {
        custom_code: customCode.trim() || undefined,
        alias: alias.trim() || undefined,
        is_whatsapp: isWhatsapp,
      };

      if (isWhatsapp) {
        payload.whatsapp_phone = whatsappPhone.trim();
        payload.whatsapp_message = whatsappMessage.trim();
      } else {
        payload.original_url = url;
      }

      const response = await api.post('/links', payload);

      if (response.data) {
        const newLink = {
          ...response.data,
          total_accesses: response.data.total_accesses || 0,
        };
        onLinkCreated(newLink);
        setUrl('');
        setCustomCode('');
        setAlias('');
        setWhatsappPhone('');
        setWhatsappMessage('');
        setIsWhatsapp(false);
        setSuccess('Link encurtado com sucesso!');
      } else {
        throw new Error('Resposta inválida do servidor');
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Erro ao criar link');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="link-form">
      <h2>Criar Novo Link Encurtado</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            value={alias}
            onChange={(e) => setAlias(e.target.value)}
            placeholder="Apelido (para você localizar) ex: Campanha Março"
            className="url-input"
            maxLength={120}
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            value={customCode}
            onChange={(e) => setCustomCode(e.target.value)}
            placeholder="Link curto personalizado (opcional) ex: meu-produto"
            className="url-input"
            maxLength={20}
          />
        </div>

        <label className="whatsapp-toggle">
          <input
            type="checkbox"
            checked={isWhatsapp}
            onChange={(e) => setIsWhatsapp(e.target.checked)}
          />
          Redirecionar para WhatsApp
        </label>

        {isWhatsapp ? (
          <>
            <div className="form-row">
              <input
                type="text"
                value={whatsappPhone}
                onChange={(e) => setWhatsappPhone(e.target.value)}
                placeholder="Telefone com DDI (ex: 5581992425794)"
                className="url-input"
                required
                maxLength={20}
              />
            </div>
            <div className="form-row">
              <textarea
                value={whatsappMessage}
                onChange={(e) => setWhatsappMessage(e.target.value)}
                placeholder="Mensagem com ph_token (ex: Olá! Recebi o token ph_token e gostaria de entender melhor.)"
                className="url-input message-input"
                required
                rows={3}
              />
            </div>
            <p className="form-hint">
              Use <code>ph_token</code> na mensagem. Ele será substituído pelo valor de <code>?tk=</code> na URL acessada.
            </p>
          </>
        ) : (
          <div className="form-row">
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://exemplo.com/url-muito-longa"
              required
              className="url-input"
            />
          </div>
        )}

        <div className="form-row form-row-submit">
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Encurtando...' : 'Encurtar'}
          </button>
        </div>
        {error && <div className="message error">{error}</div>}
        {success && <div className="message success">{success}</div>}
      </form>
    </div>
  );
};

export default LinkForm;
